/**
 * ModeratorRoute — Route guard that requires authentication AND moderator status.
 *
 * Waits for both AuthContext.isLoading and UserRelationsContext.loading to resolve
 * before making access decisions. Prevents the flash-of-redirect problem where
 * isModerator is false during the ~200-500ms relations fetch window.
 */

import React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '../../context/AuthContext'
import { useUserRelations } from '../../context/UserRelationsContext'

interface ModeratorRouteProps {
  children: React.ReactNode
}

export const ModeratorRoute: React.FC<ModeratorRouteProps> = ({ children }) => {
  const { isLoading, isAuthenticated } = useAuth()
  const { loading: relationsLoading, isModerator } = useUserRelations()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', color: '#666' }}>
        Loading...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  if (relationsLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px', color: '#666' }}>
        Loading...
      </div>
    )
  }

  if (!isModerator) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}
